module.exports = __webpack_public_path__ + "static/media/instagram.57c6657e.svg";